export const lang = {
    "loading": {
        "a1": "載入中...",
        "a2": "沒有更多了",
        // new1211
        "a3": "订阅中...",
        "a4": "缴纳中...",
        "a5": "提交中...",
        "a6": "赎回中...",
    },
    "tabbar": {
        "a1": '首頁',
        "a2": '持倉',
        "a3": '行情',
        "a4": '資產',
        "a5": '我的',
    },
    "basic": {
        "a1": "語言切換",
        "a2": "確認",
        "a3": "取消"
    },
    "notifyPopup": {
        "a3": "確定"
    },
    "gywm": {
        "a1": "關於我們",
        "a2": "公司簡介",
        "a3": "隱私權聲明",
        "a4": "服務/使用條款"
    },
    "yssm": {
        "a1": "1. 目的與適用範圍",
        "a2": "本政策旨在保障使用者（個人或法人）在使用本平台過程中其個人資料（{value}）的隱私與安全。",
        "a3": "本政策適用於所有透過本平台或其關聯網站／系統提交或處理的個人資料 — 包括開戶、交易、客服、後台管理等環節。",
        "a4": "2. 資料收集與處理類別",
        "a5": "可能收集和處理的資訊包括，但不限於：",
        "a6": "身分識別資訊：",
        "a7": "姓名、身分證／護照號碼或其他政府核發身分證件資料、出生日期、稅號（若適用）等。",
        "a8": "聯絡方式：",
        "a9": "地址、電子郵件、電話號碼等。",
        "a10": "帳戶與金融資訊：",
        "a11": "銀行帳戶或支付帳戶資訊、財務狀況、交易記錄、資金來源／用途、資產／負債狀況等。",
        "a13": "使用與存取資料：",
        "a14": "IP 位址、裝置資訊、瀏覽器類型、登入資訊、cookie／追蹤識別碼、交易行為、偏好與習慣資料。 ",
        "a15": "其他自願提供的資訊：",
        "a16": "如風險揭露資料、合規文件、驗證文件、通訊記錄等。",
        "a17": "3. 資料處理目的與法律基礎",
        "a18": "收集與處理上述資料的目的可能包括：",
        "a19": "為使用者提供交易服務、帳戶管理與客戶支援；",
        "a20": "遵守適用法律法規（包括反洗錢、身分驗證、稅務合規、證券監管等要求）；",
        "a21": "防止詐欺、洗錢、濫用平台或系統安全的情況；",
        "a22": "改善與維護系統／服務安全與穩定性；",
        "a23": "若使用者同意，也可能用於行銷、新聞／資訊通知、產品或服務推廣 — 但須事先獲得明確同意。",
        "a24": "法律基礎可能包括使用者同意（consentimiento）、合約履行必要性（prestación del servicio）、法律/監管義務（obligación legal）等。",
        "a25": "4. 第三方處理與國際資料轉移",
        "a26": "若必須將資料傳遞給第三方（例如支付處理器、身份驗證服務商、雲端儲存供應商等），平台應確保對方僅用於合約指定用途，並簽訂資料處理協議。",
        "a27": "若資料需要轉移到阿根廷境外，應採取適當的技術、組織和合約保障措施，確保接收地的資料保護水準。",
        "a28": "5. 資料保存與保留期限",
        "a29": "个人資料僅在實現相關目的所必需的期間保存，或出於遵守法律／監管要求、解決糾紛、履行合約義務所需期間。",
        "a30": "使用資料（如行為日誌、cookie 資訊等）可用於內部分析、安全監控，但保留期限應合理且符合隱私法規。",
        "a31": "6. 使用者權利",
        "a32": "使用者作為資料主體，擁有下列權利（依據阿根廷 Ley 25.326 “個人資料保護法”）：",
        "a33": "存取其個人資料（solicitar acceso）",
        "a34": "更正／補充不完整或不正確資料（rectificación）",
        "a35": "請求刪除其資料（cuando no exista base legal para處理）",
        "a36": "在法律允許範圍內反對處理（oponerse al tratamiento）",
        "a37": "若適用，可請求限制處理、資料可攜帶（data portability）等",
        "a38": "平台應提供明確管道（電子郵件、表單或書面申請）以便使用者行使這些權利，也應告知使用者負責資料處理的聯絡人/部門。",
        "a39": "7. 安全措施",
        "a40": "平台應實施適當的技術（加密、存取控制、日誌監控等）和組織措施，防止個人資料遭受未經授權存取、洩露、濫用、修改或銷毀。 ",
        "a41": "儘管採取了合理安全措施，但因互聯網固有風險，平台不能保證絕對安全。用戶理解並接受這一點。",
        "a42": "8. 政策更新與通知",
        "a43": "本隱私權政策可能不時更新。任何重大變更應透過平台公告、電子郵件或其他適當方式通知使用者。",
        "a44": "更新後的政策自公佈之日起生效，繼續使用服務則視為接受新政策。",
        "a45": "9. 適用法律與監管機構",
        "a46": "本政策受阿根廷法律管轄。",
        "a47": "監管機構為 Agencia de Acceso a la Información Pública (AAIP) 或其他適用機構，使用者可向其投訴資料保護相關問題。"
    },
    "fwtk": {
        "a1": "1. 接受條款",
        "a2": "使用者在造訪或使用本平台、建立帳戶或執行交易前，必須閱讀、瞭解並完全接受本條款。",
        "a3": "若使用者不同意本條款，則不得使用平台服務。",
        "a4": "2. 平台權利與變更條款",
        "a5": "平台保留隨時修改、暫停或終止服務、功能、內容或存取權限的權利，恕不另行通知。",
        "a6": "本條款的修改也將公佈，並自發佈時起生效。",
        "a7": "3. 合法使用與禁止行為 ",
        "a8": "使用者承諾依據適用阿根廷法律、誠信原則及公共秩序使用平台。禁止以下行為（包括但不限於）：",
        "a9": "用於任何非法目的或損害第三人權利的用途；",
        "a10": "幹擾或破壞平台正常功能、進行過度要求、發送垃圾訊息 (spam)、使用自動化腳本、機器人 (bots) 或資料抓取 / 爬蟲 (scrapers)；",
        "a11": "未經授權存取、試圖取得或揭露其他使用者/第三方帳戶或敏感資訊；",
        "a12": "上傳或傳播病毒、惡意軟體、間諜軟體或其他有害程式碼；",
        "a13": "偽造身分、冒充他人或使用虛假資料開立帳戶；",
        "a14": "未經允許轉售、轉讓帳戶或共享帳戶存取權限；",
        "a15": "利用本服務進行未經授權的廣告、行銷、競價、出售產品或服務 (除非經平台明確允許)；",
        "a16": "其他違反本條款、法律法規或平台政策的行為。",
        "a17": "若使用者違反上述規定，平台可中止或終止其帳戶，並保留採取法律行動、追究責任、索賠損失的權利。",
        "a18": "4. 責任聲明與風險告知 ",
        "a19": "平台提供的資訊（例如證券／股票報價、市場分析、新聞、研究報告等）僅供參考，不構成對使用者的投資建議、法律建議或稅務建議。",
        "a20": "使用者瞭解並承擔透過本平台進行證券交易或其他金融活動所產生的全部風險。",
        "a21": "平台對因使用 (或無法使用) 服務而導致的任何直接、間接、偶然、特殊或結果性損失 (包括但不限於盈利損失、數據丟失、系統故障等) 不承擔責任。",
        "a22": "5. 合規與反洗錢／身分驗證 (KYC/AML) ",
        "a23": "使用者開戶或進行交易時，可能需要提供身分證明 (護照、身分證等)、地址證明 (水電費帳單等)、資金來源證明 (銀行對帳單、薪資等)、以及其他反洗錢／合規所需文件／資訊。 ",
        "a24": "平台有權基於合規要求拒絕開戶或暫停交易，並不需提供使用者理由。",
        "a25": "6. 隱私權政策整合與資料使用 ",
        "a26": "使用者同意平台依本隱私權聲明收集、處理、儲存其個人資料。",
        "a27": "隱私權政策與本服務條款共同構成雙方協議 (Agreement)。",
        "a28": "7. 適用法律與爭議解決",
        "a29": "本條款受阿根廷法律管轄。若發生爭議，應提交布宜諾斯艾利斯 (或平台所在地) 普通法院 (ordinary courts) 解決。",
        "a30": "8. 聯絡方式 ",
        "a31": "使用者諮詢隱私、資料保護、條款內容、帳戶交易等問題可聯絡{value}回饋。"
    },
    "addDebitCard": {
        "a1": "添加銀行卡",
        "a2": "姓名",
        "a3": "請輸入姓名",
        "a4": "銀行名稱",
        "a5": "請輸入銀行名稱",
        "a6": "請輸入22位{value}",
        "a7": "賬戶類型",
        "a8": "請輸入賬戶類型",
        "a9": "提交",
        // 
        "c1": "綁定成功",
        "c2": "必須是22位純數字",
        "c3": "銀行地址",
        "c4": "請輸入銀行地址",
        "c5": "银行账号",
        "c6": "请输入银行账号",
        "c7": "请输入SWIFT"
    },
    "asset": {
        "a1": "總資產",
        "a2": "市值",
        "a3": "可用餘額",
        "a4": "佔用金額",
        "a5": "總收益",
        "a6": "儲值",
        "a7": "提現",
        "a8": "資產轉換",
        "a9": "資金記錄",
        "a10": "資金密碼",
        "a11": "申請貸款",
        "a12": "儲值方式",
        "a13": "提現方式",
        // new
        "c1": "實名提示",
        "c2": "立即認證",
        "c3": "取消",
        "c4": "提現需實名認證，是否前往認證？",
        "c5": "查看實名",
        "c6": "實名認證審核中，請通過後再提現！"
    },
    "assetConversion": {
        "a1": "資產轉換",
        "a2": "資金記錄",
        "a3": "從",
        "a4": "可用餘額",
        "a5": "请输入申請金額",
        "a6": "請選擇需要轉換幣種",
        "a7": "到",
        "a8": "當前餘額:",
        "a9": "到賬金額",
        "a10": "轉換金額以實際到賬為準",
        "a11": "立即提交"
    },
    "dayTrading": {
        "a1": "AI交易",
        "a2": "訂單提交",
        "a3": "已申請",
        "a4": "交易中",
        "a5": "交易明細",
        "a6": "參與時間段:",
        "a7": "請輸入您的參與金額(最低{value})",
        "a8": "提交",
        "a9": "訂單編號",
        "a10": "訂單狀態",
        "a11": "待審核",
        "a12": "訂單金額",
        "a13": "已駁回",
        "a14": "訂單編號",
        "a15": "訂單狀態",
        "a16": "已平倉",
        "a17": "交易類型",
        "a18": "買漲",
        "a19": "平倉時間",
        "a20": "交易數量",
        "a21": "買入價格",
        "a22": "買入總價",
        "a23": "手續費",
        "a24": "賣出價格",
        "a25": "賣出總價",
        "a26": "盈利金額",
        "a27": "確認",
        "a28": "取消",
        "a29": "產品介紹",
        "a30": "基於阿根廷交易所全股指數，運用人工智慧模型實現多元化的市場配置，同時保持穩定的風險控制並實現持續成長。",
        "a31": "該基金專注於美國市值最大、流動性最強的30檔股票，採用等權重策略分散投資風險。 Broking AI Quant NGX全市場基金緊密追蹤NGX全股指數（ASI），因此適合長期穩定的投資組合配置。",
        "a32": "五天投資，預期日收益率1.5%至3%，平均投資額400萬比索可獲利9萬比索。美國中小市值成長基金旨在投資以成長為導向的中小型企業，提供靈活的回報。",
        "a33": "重點關注國有企業和領先的油氣公司，將政策支持與能源產業的穩定回報相結合。",
        "a34": "預計收益",
        "a39": "投資策略",
        "a40": "交易週期",
        "a41": "總利率:{value}",
        "a42": "交易金額",
        "a43": "可用餘額：{value}",
        "a44": "最低限額{value}",
        "a45": "餘額不足",
        // new
        "c1": "交易金額不能為空",
        // new1206
        "a35": "基於{value}萬比索的投資，預計在1至3個交易日內實現每個交易日0.5%至1%的回報，平均每個交易日盈利約為{value2}比索",
        "a36": "基於{value}萬比索的投資，預計在1至3個交易日內實現每個交易日1%至1.5%的回報，平均每個交易日盈利約為{value2}比索",
        "a37": "投資 {value} 萬比索，為期5個交易日，預期收益率為每個交易日 1.5% 至 2%，平均每個交易日利潤為 {value2}萬比索。",
        "a38": "投資 {value} 萬比索，為期7個交易日，預期收益率為每個交易日 3% 至 5%，平均每個交易日利潤為 {value2} 萬比索。",
        "b1": "{value}天"
    },
    "etf": {
        "a1": "產品贖買",
        "a2": "歷史訂單",
        "a3": "訂單編號",
        "a4": "產品",
        "a5": "週期(天)",
        "a6": "購買時間",
        "a7": "到期時間",
        "a8": "投資金額",
        "a9": "總獲利預期",
        "a10": "持有天數",
        "a11": "釋放金額",
        "a12": "狀態",
        "a13": "已贖回",
        // 
        "c1": "待確認",
        "c2": "交易中",
        "c3": "交易密碼"
    },
    "fundAccountManage": {
        "a1": "財務帳戶管理",
        "a2": "添加銀行卡",
        // newText
        "a3": "銀行卡管理",
        "a4": "地址綁定",
        "a5": "地址類型",
        "a6": "地址",
        "a7": "刪除確認",
        "a8": "確認",
        "a9": "取消",
        "a10": "是否確認刪除此卡？",
        "a11": "ERC地址不能為空",
        "a12": "TRC地址不能為空",
        "a13": "已綁定地址如需更改請聯絡客服",
        "a14": "ERC20地址",
        "a15": "TRC20地址",
    },
    "fundingRecords": {
        "a1": "資金記錄",
        "a2": "購買明細",
        "a3": "存入資金",
        "a4": "提現",
        "a5": "轉換",
        "a6": "已到賬",
        "a7": "申請金額",
        "a8": "實際到帳金額",
        "a9": "金額",
        "a10": "時間",
        // newText
        "a11": "收入",
        "a12": "支出",
        "a13": "充值金額",
        "a14": "未完成",
        "a15": "已完成",
        "a16": "已取消",
        "a17": "待審核",
        "a18": "已到賬",
        "a19": "審核未通過",
        "a20": "提現退款",
    },
    "fundPassword": {
        "a1": "資金密碼",
        "a2": "原密碼",
        "a3": "請輸入原密碼",
        "a4": "新密碼",
        "a5": "請輸入新密碼",
        "a6": "確認密碼",
        "a7": "請輸入確認密碼",
        "a8": "立即提交",
        // newText
        "a9": "請輸入6位純數字密碼",
        "a10": "必須是 6 位數字",
        "a11": "密碼",
        "a12": "請輸入確認密碼",
        "a13": "兩次密碼不一致"
    },
    "index": {
        "a1": "大宗訂單",
        "a2": "日內交易",
        "a3": "實名認證",
        "a4": "線上客服",
        "a5": "全球指數",
        "a6": "更多",
        "a7": "熱門股票",
        "a8": "自選",
        "a9": "阿根廷",
        "a10": "美股",
        "a11": "股票/代碼",
        "a12": "最新價格({value})",
        "a13": "漲跌幅",
        // newText
        "a14": "智能交易系統",
        "a15": "基於深度學習（Deep Learning）演算法，回測過去10年海量行情數據。",
        "a16": "快速、安全、流暢。重新定義大宗交易。",
        "a17": "大宗折扣",
        "a18": "新聞熱點",
        "a19": "關於我們",
        "a20": "常見問題",
        "a21": "暫無數據",
        "a22": "完成 KYC 認證，領取體驗金",
        "a23": "實名認證",
        "a24": "恭喜您透過KYC認證,系統已發放體驗金券到您的帳戶",
        "a25": "立即開啟投資",
        "a26": "自動 AI 智投中",
        "a27": "查看收益",
        "a28": "最新價格",
        "a29": "持倉中",
        "a30": "已平倉",
        "a31": "可用资金"
    },
    "ipo": {
        "a1": "股票認購",
        "a2": "已認購",
        "a3": "交易中",
        "a4": "交易明細",
        "a5": "自動訂閱",
        "a6": "未中籤",
        "a7": "申購數量",
        "a8": "中籤時間",
        "a9": "中籤數量",
        "a10": "預計盈利",
        "a11": "待繳納",
        "a12": "已繳納",
        "a13": "招股價",
        "a14": "市場現價",
        "a15": "已平倉",
        // newText
        "a16": "待中簽",
        "a17": "已中簽",
        "a18": "已駁回",
        "a19": "交易密碼",
        "a20": "產品詳情",
        "a21": "發行數量",
        "a22": "發行價格",
        "a23": "股票代碼",
        "a24": "匯率",
        "a25": "截止時間",
        "a26": "立即申購",
        "a27": "訂單編號",
        "a28": "截止時間",
        "a29": "立即繳費",
        "a30": "中簽價格",
        "a31": "中簽股數",
        "a32": "中簽總價",
        "a33": "總計收益",
        "a34": "上市時間",
        "a35": "發佈時間",
        "a36": "駁回原因",
        ///
        "a37": "待審核",
        "a38": "待繳費",
        "a39": "等待上市",
        "a40": "已平倉",
        "a41": "已駁回",
        "a42": "已申購",
        "a43": "已截止",
        "a44": "贖回",
    },
    "login": {
        "a1": "請輸入手機號",
        "a2": "請輸入密碼",
        "a3": "線上客服",
        "a4": "忘記密碼?",
        "a5": "安全登入",
        "a6": "沒有帳號？",
        "a7": "去註冊",
        // newText
        "a8": "登入",
        "a9": "歡迎回來，請登入您的帳戶",
        "a10": "手機號格式不正確",
        "a11": "登入成功",
    },
    "register": {
        "a1": "請再次輸入密碼",
        "a2": "邀請碼(必填)",
        "a3": "已有帳號？",
        "a4": "去登入",
        "a5": "安全註冊",
        // newText
        "a6": "註冊",
        "a7": "註冊新賬號",
        "a8": "請輸入手機號",
        "a9": "手機號格式不正確",
        "a10": "請輸入密碼",
        "a11": "至少 6 位且字母和數字組合",
        "a12": "請輸入確認密碼",
        "a13": "兩次輸入的密碼不一致",
        "a14": "請輸入邀請碼",
        "a15": "請輸入身分ID",
        "a16": "請先同意協議",
        "a17": "同意",
        "a18": "註冊協議",
        "a19": "註冊須知",
        "a20": "同意",
        "a21": "帳號資訊",
        "a22": "使用者資訊",
        "a23": "姓名",
        "a24": "請輸入姓名",
        "a25": "選擇國籍",
        "a26": "正面",
        "a27": "從您的裝置中選擇",
        "a28": "請上傳您的身分證正面照片。",
        "a29": "請上傳您身分證背面的照片。",
        "a30": "背面",
        "a31": "信箱",
        "a32": "請輸入信​​箱",
        "a33": "請輸入正確的郵箱格式",
        "a34": "居住地址",
        "a35": "請輸入居住地址",
        "a36": "年收入",
        "a37": "請選擇年收入",
        "a38": "淨資產",
        "a39": "請選擇淨資產",
        "a40": "投資經驗",
        "a41": "請選擇投資經驗",
        "a42": "風險承受能力",
        "a43": "請選擇風險承受能力",
        "a44": "不能超過5MB",
        "a45": "上傳中...",
        "a46": "0 - 5萬",
        "a47": "5萬 - 10萬",
        "a48": "10萬 - 20萬",
        "a49": "20萬 - 50萬",
        "a50": "50萬以上",
        "a51": "有經驗",
        "a52": "無經驗",
        "a53": "穩健型",
        "a54":"進取型"
    },
    "mail": {
        "a1": "通知",
        "a2": "刪除",
        // newText
        "a3": "系統公告",
        "a4": "訂單通知",
        "a5": "訂單號",
        "a6": "審核結果",
        "a7": "體驗金通知",
        "a8": "私信通知",
        "a9": "幣種",
        "a10": "市場價格",
        "a11": "購入價",
        "a12": "到期時間",
        "a13": "透過"
    },
    "market": {
        "a1": "請輸入股票名稱",
        "a2": "搜尋",
        "a3": "自選",
        "a4": "阿根廷股",
        "a5": "美股",
        "a6": "資訊",
        "a7": "股票/代碼",
        "a8": "最新價格",
        "a9": "漲跌幅",
        // newText
        "a10": "最新價格",
        // new1210
        "a11": "查看詳情",
        "a12": "積極的",
        "a13": "消極的",
        "a14": "中性的",
        "a15": "港股",
        "a16": "基金",
        "a17": "期貨",
    },
    "marketDetail": {
        "a1": "行情",
        "a2": "今開",
        "a3": "昨收",
        "a4": "最高",
        "a5": "最低",
        "a6": "買入",
        "a7": "買入總價",
        "a8": "可用資金",
        "a9": "總資金",
        "a10": "槓桿倍數",
        "a11": "買入數量",
        "a12": "請輸入購買數量",
        "a13": "止盈價格",
        "a14": "請輸入止盈價格",
        "a15": "止損價格",
        "a16": "請輸入止損價格",
        "a17": "購買訂單",
        "a18": "時間:",
        "a19": "開盤:",
        "a20": "收盤:",
        "a21": "最低:",
        "a22": "最高:",
        // newText
        "a23": "當前價格",
        "a24": "是否開啟止盈",
        "a25": "是否開啟止損",
        "a26": "您的資金最多只能買",
        "a27": "股",
        "a28": "請輸入買入股數",
        "a29": "請輸入止損價格",
        "a30": "止損價格不能大於當前價格",
        "a31": "請輸入止盈價格",
        "a32": "止盈價格不能小於當前價格",
        "a33":"買入股票",
        "a34":"賣出股票",
        "a35":"持有數量",
        "a36":"平均價格",
        "a37":"股票",
        "a38":"限價",
        "a39":"市場",
        "a40":"停價",
        "a41":"服役時間",
        "a42":"賣出總額",
        "a43":"賣出數量",
        "a44":"賣出訂單",
        "a45":"限價",
        "a46":"市場",
        "a47":"停止價格",
        "a48":"賣出"
    },
    "mine": {
        "a1": "已實名",
        "a2": "可用資金",
        "a3": "可用資金",
        "a4": "實名認證",
        "a5": "修改登入密碼",
        "a6": "財務管理",
        "a7": "線上客服",
        "a8": "語言切換",
        "a9": "登出",
        // newText
        "a10": "審核中",
        "a11": "未通過",
        "a12": "未實名",
        "a13": "反詐騙專區",
        "a14": "監管資訊",
        "a15": "风险披露",
    },
    "newsDetail": {
        "a1": "資訊"
    },
    "otc": {
        "a1": "訂單提交",
        "a2": "待審核",
        "a3": "交易明細",
        "a4": "已駁回",
        "a5": "市場現價",
        "a6": "折扣價格",
        "a7": "一股收益",
        "a8": "最低買入股數",
        "a9": "請輸入購買數量",
        "a10": "買入總價",
        "a11": "可用餘額",
        "a12": "確認",
        "a13": "待審核",
        "a14": "買入時間",
        "a15": "交易數量",
        "a16": "市場現價",
        "a17": "折扣價格",
        "a18": "申購總資金",
        "a19": "已平倉",
        "a20": "已駁回",
        // newText
        "a21": "大宗折扣",
        "a22": "產品訂閱",
        "a23": "已分配",
        "a24": "交易明細",
        "a25": "已駁回",
        "a26": "訂閱價格",
        "a27": "當前價格",
        "a28": "溢價",
        "a29": "發佈時間",
        "a30": "截止時間",
        "a31": "已訂閱",
        "a32": "立即訂閱",
        "a33": "待付款",
        "a34": "訂單號",
        "a35": "訂閱價格",
        "a36": "分配股數",
        "a37": "訂閱總價",
        "a38": "已繳納",
        "a39": "待繳納",
        "a40": "預計盈利",
        "a41": "訂閱時間",
        "a42": "立即繳納",
        "a43": "持倉中",
        "a44": "開始時間",
        "a45": "到期時間",
        "a46": "贖回",
        "a47": "駁回原因",
        "a48": "訂閱確認",
        "a49": "確認",
        "a50": "取消",
        "a51": "立即訂閱獲得更多收益！您確認訂閱？",
        "a52": "繳納確認",
        "a53": "立即繳納獲得更多收益！您確認立即繳納？",
        "a54": "贖回確認",
        "a55": "您確認立即贖回？",
        "a56": "賣出確認",
        "a57": "繼續持倉將獲得更多收益！您確認立即賣出？",
        // new1206
        "c1": "恭喜您訂閱成功",
        "c2": "缴纳截止时间"
    },
    "positionDetails": {
        "a1": "投資詳情",
        "a2": "已平倉",
        "a3": "訂單號",
        "a4": "賣出價格",
        "a5": "賣出時間",
        "a6": "買入時間",
        "a7": "交易類型",
        "a8": "買漲",
        "a9": "平倉數量",
        "a10": "買入價格",
        "a11": "合同金額",
        "a12": "手續費",
        "a13": "平倉手續費",
        "a14": "現價",
        "a15": "實際盈虧",
        "a16": "收益率",
        "a17": "槓桿倍數",
    },
    "realNameAuthentication": {
        "a1": "實名認證",
        "a2": "已通過",
        "a3": "身份證驗證",
        "a4": "上傳人像面",
        "a5": "上傳反面",
        "a6": "真實姓名",
        "a7": "請輸入真實姓名",
        "a8": "身份證號",
        "a9": "請輸入身份證號(8位)",
        "a10": "提交",
        // newText
        "a11": "已實名",
        "a12": "審核中",
        "a13": "未通過審核,請重新提交",
        "a14": "電話",
        "a15": "請輸入電話",
        "a16": "郵箱",
        "a17": "請輸入郵箱(选填)",
        "a18": "請上傳身份證",
        "a19": "請填寫姓名",
        "a20": "請填寫身份證號",
        "a21": "請填電話",
        "a22": "郵箱格式不正確",
        "a23": "身份證是 11 位數字",
        "a24": "電話是 10 位數字",
        // newText2
        "c1": "提示",
        "c2": "確認",
        "c3": "提交成功,請等待審核!",
        // new1208
        "c4": "駁回原因"
    },
    "topUp": {
        "a1": "儲值",
        "a2": "複製",
        // newText
        "a3": "儲值金額",
        "a4": "請輸入金額",
        "a5": "最低",
        "a6": "需支付金額",
        "a7": "手續費",
        "a8": "實際金額",
        "a9": "如需其他付款通道，請聯絡客服",
        "a10": "聯絡客服",
        "a11": "通知",
        "a12": "聯絡客服",
        "a13": "取消",
        "a14": "當前時間禁止轉帳,請在9:00到22:00之間進行操作如有疑問請聯絡客服或使用虛擬貨幣儲值",
        "a15": "最小充值金額為",
        "a16": "請輸入充值金額",
        "a17": "正在加載支付頁面...",
        "a18": "儲值",
        "a19": "如需其他付款通道，請聯絡客服",
        "a20": "說明：該通道僅支援{ value }鏈虛擬幣充值，且最低充值{ value2 }",
        "a22": "複製成功",
    },
    "transaction": {
        "a1": "阿根廷",
        "a2": "美股",
        "a3": "請輸入搜尋關鍵字",
        "a4": "搜尋",
        "a5": "配售",
        "a6": "ETF 持倉",
        "a7": "進行中",
        "a8": "已結束",
        "a9": "市值{value}",
        "a10": "可用資金{value}",
        "a11": "盈虧{value}",
        "a12": "未中籤",
        "a13": "已平倉",
        "a14": "預計盈利",
        "a15": "申購價格{value}",
        "a16": "申購數量",
        "a17": "分配日期",
        "a18": "中簽",
        "a19": "已認繳{value}",
        "a20": "需認繳{value}",
        "a21": "股票名稱",
        "a22": "現價{value}",
        "a23": "成本{value}",
        "a24": "持有",
        "a25": "市值",
        "a26": "損益",
        "a27": "持倉中",
        "a28": "回報率",
        "a29": "買入時間",
        "a30": "到期時間",
        "a31": "基金名稱",
        "a32": "買入金額",
        "a33": "日收益",
        "a34": "日收益率",
        "a35": "總收益",
        "a36": "總收益率",
        "a37": "交易週期",
        "a38": "股票名稱",
        "a39": "賣出價格{value}",
        "a40": "平倉數量",
        "a41": "盈虧",
        "a42": "損益",
        "a43": "已平倉",
        // newText
        "a44": "AI交易",
        "a45": "大宗折扣",
        "a46": "股票",
        "a47": "持倉中",
        "a48": "訂單號",
        "a49": "訂閱價格",
        "a50": "分配股數",
        "a51": "訂閱總價",
        "a52": "已繳納",
        "a53": "待繳納",
        "a54": "預計盈利",
        "a55": "開始時間",
        "a56": "到期時間",
        "a57": "贖回",
        "a58": "盈收",
        "a59": "賣出",
        "a60": "交易中",
        "a61": "交易週期",
        "a62": "天",
        "a63": "預計盈利",
        "a64": "到期時間",
        "a65": "訂閱時間",
        "a66": "贖回確認",
        "a67": "確認",
        "a68": "取消",
        "a69": "您確認立即贖回？",
        "a70": "賣出確認",
        "a71": "您確認立即賣出？",
        // new1206
        "d1": "平倉",
        "d2": "止盈",
        "d3": "止損",
        "d4":"買入待成交",
        "d5":"賣出待成交",
        "d6":"數量",
        "d7":"掛單中",
        "d8":"取消",
        "d9":"取消確認",
        "d10":"您確定取消該筆交易？"
    },
    "updateLoginPassword": {
        "a1": "修改登入密碼",
        "a2": "原密碼",
        "a3": "請輸入原密碼",
        "a4": "新密碼",
        "a5": "請輸入新密碼",
        "a6": "確認密碼",
        "a7": "請輸入確認密碼",
        "a8": "立即提交",
        // newText
        "a9": "至少 6 位且字母和數字組合",
        "a10": "兩次輸入的密碼不一致",
    },
    "withdrawal": {
        "a1": "提現",
        "a2": "可用資金",
        "a3": "銀行卡",
        "a4": "請選擇銀行卡",
        "a5": "請輸入提現金額",
        "a6": "提交",
        "a7": "請選擇 銀行卡",
        "a8": "去綁定",
        "a9": "確認",
        // newText
        "a10": "實際到賬",
        "a11": "手續費",
        "a12": "安全提示",
        "a13": "確認",
        "a14": "請先設置交易密碼",
        "a15": "提交成功，目前銀行交易比較擁堵，資金將於24H內到賬",
        "a16": "請選擇銀行卡",
        "a17": "請輸入提現金額",
        "a18": "最低提現金額",
        // 
        "c1": "提交成功",
    },
    // 阿根廷语言包缺失
    "notifyPopupOtc": {
        "a1": "大宗折扣訂閱通知",
        "a2": "您有多個大宗折扣產品待訂閱",
        "a3": "您有一個大宗折扣產品待訂閱",
        "a4": "股票名稱:",
        "a5": "訂閱價格:",
        "a6": "市場價:",
        "a7": "幣種:",
        "a8": "截止時間:",
        "a10": "股票類型:",
        "a11": "購買價:",
        "a12": "股數:",
        "a13": "股票交易代碼:",
        "a14": "訂單號:",
        "a15": "繳費時間:",
        "a16": "公司名:",
        "a17": "股票類型:",
        "a18": "金額:",
        "a19": "訂單號:",
        "a20": "審核狀態:",
        "a21": "使用者備註:",
        // new1206,
        "a9": "股票名稱:",
        "d1": "您有多個大宗訂單分配成功",
        "d2": "您有一個大宗訂單分配成功",
        "d3": "大宗訂單通知",
        "d4": "您有多個大宗訂單被駁回",
        "d5": "您有一個大宗訂單被駁回",
        "d6": "大宗訂單駁回通知",
        "d7": "駁回"
    },
    "tyjPopup": {
        "a1": "體驗金",
        "a2": "剩餘領取時間",
        "a3": "體驗金",
        "a4": "確定",
        // newText
        "a5": "恭喜您身份審核通過",
        "a6": "獲得",
        "a7": "體驗金",
        "a8": "活動倒數計時",
        "a9": "立即投資",
    },
    "aiTransactionDetails": {
        "a1": "交易詳情",
        "a2": "日期",
        "a3": "當日盈利",
        "a4": "持股詳情",
        "a5": "買入價格",
        "a6": "賣出價格",
        "a7": "持股數量",
        "a8": "當日收益",
        // 
        "c1": "智能交易中...",
    },
    "aiTransactionRecords": {
        "a1": "AI交易記錄",
        "a2": "交易中",
        "a3": "交易明細",
        "a4": "交易週期",
        "a5": "預計盈利",
        "a6": "到期時間",
        "a7": "訂閱時間",
        "a8": "查看詳情",
        "a9": "天",
        // new
        "c1": "待確認",
        "c2": "交易中",
        "c3": "已平倉",
        "c4": "任務失敗"
    },
    "fqa": {
        "a1": "常見問題",
        "a2": "我們Matrix受阿根廷政府邀請，基於全球第二大交易所NASDAQ進行交易，受到美國證券交易委員會（SEC）和金融行業監管局（FINRA）嚴格監管，其投資行為具有高度的權威性和可信度。",
        "a3": "目前屬於初步推廣期，交易不收任何費用，提現收取1-千分之三的手續費。匯率按正常比索互兌美元匯率。",
        "a4": "資金存入沒有任何費用，大額資金需提前報備。都是受政府和銀行正規監管，無任何風險提示。",
        "a5": "市場的行情正常波動，肯定存在對應的收益和風險，但公司均提供AI交易、大宗折扣等穩定收益的操作。",
        "a6": "平台是基於正規阿根廷股票和美股交易行情運行，實時保持一致。",
        "a7": "均受美國證券交易委員會（SEC）和金融行業監管局（FINRA）嚴格監管。提現正常收取手續費！",
        "a8": "客戶支援綁定自己的資訊和銀行卡，以及操作APP內所有相關功能，但如未成功交易或申購，是市場行為，與公司無關，如有糾紛可向Matrix公司客服和正規監管部門申訴。",
        "a9": "客戶需要正常操作手機APP功能和理解股市風險，每個客戶都有獨立KYC認證後方可交易，不可盜用他人身份認證等進行交易操作。",
        "a11": "1.該平台是否合法 & 受監管嗎？",
        "a12": "2.交易費用、佣金、匯率和成本如何計算？",
        "a13": "3.資金存入/提現是否安全？",
        "a14": "4.市場 / 流動性 / 波動性風險高不高？",
        "a15": "5.數據是否準確？",
        "a16": "6.法律稅務責任是否合法？",
        "a17": "7.交易資金是否安全，出現爭議如何申訴？",
        "a18": "8.客戶應如何使用我們產品？"
    },
    // newText
    "loan": {
        "a1": "申請貸款",
        "a2": "手機號",
        "a3": "請輸入手機號",
        "a4": "手機號格式不正確",
        "a5": "姓名",
        "a6": "請輸入姓名",
        "a7": "郵箱",
        "a8": "請輸入郵箱",
        "a9": "金額",
        "a10": "請輸入貸款金額",
        "a11": "您暫無貸款資格，請聯絡客服諮詢",
    },
    "loanRecords": {
        "a1": "貸款記錄",
        "a2": "貸款人",
        "a3": "待審核",
        "a4": "審核通過",
        "a5": "審核拒絕",
    },
    "withdrawalu": {
        "a1": "提現地址",
        "a2": "實際到賬",
        "a3": "手續費",
        "a4": "綁定提示",
        "a5": "確認",
        "a6": "請先綁定TRC提現地址",
        "a7": "安全提示",
        "a8": "請先設置交易密碼",
        "a9": "提現地址不可為空",
        "a10": "請輸入提現金額",
        "a11": "最低提現金額",
        "a12": "請先綁定ERC提現地址",
    },
    "about": {
        "a1": "是一家早期風險投資公司，投資範圍涵蓋從創意階段到 A 輪融資的各個階段。我們團隊由一群前創始人及公司建設者組成，關係緊密，曾與蘋果、聯邦快遞、Oculus 和 Canva 等公司合作。",
        "a2": "我們是逆向投資者，憑藉堅定的信念進行投資，與擁有深厚技術專長和明確未來願景的創始人合作。",
        "a3": "團隊",
        "a4": "我們是一支由前創始人及公司建設者組成的緊密團隊。我們投資項目精挑細選，但樂於投入時間。",
        "a5": "我們穩扎穩打，及早參與，並且經久耐用。",
        "a6": "投資",
        "a7": "Ilya Sukhan",
        "a8": "AI、基礎設施",
        "a9": "August Health、Chameleon、Fivetran、Flock Safety、Mashgin、Parabola、Sieve",
        "a10": "Dana Stalder",
        "a11": "金融科技、B2B",
        "a12": "ApartmentList、Baselane、EarnIn、Flexible Finance、Mudflap、Side、Steadily、Zest AI",
        "a13": "Antonio Rodriguez",
        "a14": "AI、前沿科技",
        "a15": "August Health、Chameleon、Fivetran、Flock Safety、Mashgin、Parabola、Sieve",
        "a16": "Kojo Osei",
        "a17": "AI、基礎設施",
        "a18": "Hookdeck、Ampersand、LM Studio",
        "a19": "項目",
        "a20": "挑戰者、逆向思維者、冒險家和現狀打破者。我們投資組合中的公司由擁有深厚技術專長和對未來獨特願景的創始人創立。",
        "a21": "接觸 了解我們永遠不會太早",
        "a22": "舊金山",
        "a23": "加利福尼亞州舊金山米慎街535號2600室，郵編94105，電話：650-798-1600",
        "a24": "波士頓",
        "a25": "馬薩諸塞州劍橋市主街101號17樓，郵編02142，電話：617-494-1223",
    },
    "AiTrialBonus": {
        "a3": "領取體驗金",
        "a4": "開始 AI 智投",
        "a5": "賺取收益",
        "a6": "體驗金策略",
        "a7": "智投週期",
        "a8": "預計收益率",
        "a9": "體驗金",
        "a10": "提交",
        "a11": "我的收益",
        "a12": "當前投資總收益",
        "a13": "每日收益",
        "a14": "買入",
        "a15": "賣出",
        "a16": "持有數量",
        "a17": "收益",
        "a18": "等待收益中",
        "a19": "活動提醒",
        "a20": "返回",
        "a21": "該活動已結束！",
        // new1208
        "a1": "領取體驗金",
        "a2": "AI 演算法分析 + 專業風險控制，讓每一次投資都透明、安全、可控 — 為你的資產保駕護航",
        "b1": "用 AI · 贏未來財富",
        "b2": "天"
    },
    "notifyPopupKyc": {
        "a1": "恭喜您註冊成功,請立即前往實名認證!",
        "a2": "前往認證"
    },
    "store": {
        "a1": "實名提示",
        "a2": "立即認證",
        "a3": "取消",
        "a4": "交易需實名認證，是否前往認證？",
        "a5": "查看認證",
        "a6": "實名認證審核中，暫不可交易！"
    },
    // 1209
    "newRouter": {
        "a1": "請先登入",
        "a2": "登入中...",
        "a3": "註冊中..."
    },
    "utils": {
        "a1": "{value}天 {value2}時 {value3}分 {value4}秒"
    },
    "oneStocks": {
        "a1": "最高",
        "a2": "最低",
        "a3": "平均價",
        "a4": "成交量",
        "a5": "昨開",
        "a6": "昨收",
        "a7": "振幅",
        "a8": "高水",
        "a9": "去交易",
        "a10": "分時",
        "a11": "日K",
        "a12": "週K",
        "a13": "月K",
        "a14": "季K",
        "a15": "年K"
    },
    "antiFraud": {
        "a1": "反詐騙專區",
        "a2": "詐欺鑑定",
        "a3": "您可複製簡訊/訊息中的官方連結或聯絡資訊進行驗證，請勿點擊非官方來源連結或輸入任何帳號密碼訊息",
        "a4": "提交",
        "a5": "重要公告",
        "a6": "詐欺報告途徑",
        "a7": "空殼公司騙局",
        "a8": "「拉高出貨」或「唱高散貨」騙局",
        "a9": "「唱空吸籌」騙局!",
        "a10": "退休金帳戶騙局!",
        "a11": "殺熟詐騙!",
        "a12": "我們將嚴格保護您的個人資訊安全",
        "a13": "您的信任對我們非常重要，我們深知個人資訊對您的重要性，我們將依照法律法規要求，採取嚴格安全保護措施，全力保障您的個人資訊安全。具體您可以透過以下「隱私權政策」、「服務條款」進行了解",
        "a14": "隱私權政策",
        "a15": "服務條款",
        "a16": "鑑定內容不可為空",
        "a17": "提交成功！請耐心等待客服聯絡您",
        "a18": "詐欺報告途徑",
        "a19": "美國聯邦調查局 — 犯罪投訴中心",
        "a20": "英國國家詐欺與網路犯罪報告中心",
        "a21": "韓國國家警察廳",
        "a22": "日本國家警察廳",
        "a23": "歐盟",
        "a24": "詳情",
        "a25": "任何人都可能成為金融詐騙和詐欺的目標。最好的防禦方法是保持知情、警覺和安全。以下是有關最常見的金融服務詐騙的信息，以及幫助您避免成為下一個受害者的關鍵建議和提示！",
        "a26": "空殼公司騙局",
        "a27": "騙子可能會假裝來自正當合法的公司，誘使您轉移到其帳戶。在部分情況下，騙子可能會假裝代表或來自一家聲譽良好的金融服務公司，包括盈透證券。空殼公司騙局的目的是引誘您轉移到一個看似正當、但實際上是由騙子持有的帳戶。",
        "a28": "「拉高出貨」或「唱高散貨」騙局",
        "a29": "在這些騙局中，騙子會先投資一隻股票，然後散佈錯誤或誤導資訊以營造出搶購的氛圍，人為地「拉高」股價。然後，騙子會趁高價「拋售」其自有股份並停止唱多該股票，隨著股價下滑，其它投資者將蒙受損失。這些來自「知情人士」的「第一手」投資建議訊息，會基於您享有的特權或特殊地位而向您提供。",
        "a30": "「唱空吸籌」騙局",
        "a31": "這與「拉高出貨」騙局剛好相反。在「唱空吸籌」騙局中，騙子會散佈錯誤的訊息，使投資者相信一支流動性相對偏低的股票將大幅下跌並應當賣出。當投資者看到有關資訊而賣出該股票，導致價格大幅下滑時，騙子將進場以低價買入股份。",
        "a32": "退休金帳戶騙局",
        "a33": "要從退休金帳戶提款，領取者需達到最低年齡要求。一般而言，提早領取退休金往往會被徵收罰款。在這種騙局中，騙子會自稱可通過稅務漏洞，幫助提早領取退休金而無需支付罰款，然後運用複雜的計劃，透過佣金、投資等方式侵蝕退休金帳戶的資產。",
        "a34": "殺熟詐騙",
        "a35": "進行殺熟詐騙的騙子通常是（或假扮成）目標被詐騙群體中的一員。騙子明白人性較容易信任與自己背景相似的人，因此會透過年齡、宗教、種族、性別或專業身分等方式以獲得受害者的信任。殺熟詐騙幾乎必然涉及偽造投資或一項騙子隱瞞了重要資訊的投資（例如虧損風險、投資往績、或計劃發起者的背景）。",
        "a36": "不少殺熟詐騙是屬於龐氏或金字塔式騙局，新投資者向計畫發起者提供的資金將支付予較早的投資者，以創造出所謂投資成功的假象。最後，當新投資者的資金耗盡而現有投資者要求收取回報時，騙局就會垮掉，投資者才發現其大部分甚至全部資金已被蒸發。"
    },
    "Regulatorynfo": {
        "a0": "監管資訊",
        "a1": "已在美國證券交易委員會 (SEC) 註冊，並為美國金融業監理局 (FINRA) 成員。遵守客戶保護規則（SEC 規則 15c3-3）：客戶的現金和證券與公司自有資產隔離，並存放於受保護的帳戶中。符合 FATCA/W-8BEN 法規：非美國客戶須遵守美國國稅局 (IRS) 的稅務申報和預扣稅規定。",
        "a2": "FINRA 和 SIPC 會員證券受 SIPC 保護，最高可達 500,000 美元（含 250,000 美元現金）。不受 FDIC 保險保障 • 無銀行擔保 • 可能損失價值 © 2026 Matrix Quant Inc. 保留所有權利。",
    },
    "riskDisclosure": {
        "a0": "風險揭露",
        "a1": "所有投資都存在風險，並非適合所有投資者。",
        "a2": "您可能會損失部分或全部投資本金。",
        "a3": "過往業績並不代表未來表現。",
        "a4": "市場波動、經濟狀況和地緣政治事件可能會對資產價格產生不利影響。",
        "a5": "保證金交易風險",
        "a6": "保證金交易涉及重大風險。",
        "a7": "你損失的金額可能會超過你帳戶中的存款金額。",
        "a8": "為了滿足追加保證金的要求，本公司可能會在不事先通知的情況下清算您的證券。",
        "a9": "您無權要求延長追加保證金通知的期限。",
        "a10": "選擇權交易風險",
        "a11": "期權交易涉及風險，並非適用於所有投資者。",
        "a12": "交易前請先閱讀《標準化選擇權的特性與風險》。",
        "a13": "您可能會損失已支付的全部保費。",
        "a14": "出售選擇權可能導致無限的損失。",
        "a15": "日內交易風險",
        "a16": "日內交易可能導致重大損失。",
        "a17": "日內交易者必須保持至少 25,000 美元的淨資產。",
        "a18": "快速交易可能導致高昂的交易成本。",
        "a19": "由於系統故障、連線問題或市場波動，交易執行可能會延遲或無法進行。",
        "a20": "在快速波動的市場中，價格可能會大幅下跌。",
        "a21": "監管通知",
        "a22": "證券交易由 MatrixQuant Inc 提供，該公司是美國證券交易委員會 (SEC) 註冊的經紀交易商，也是 FINRA 和 SIPC 的成員。"
    }
};